import React from 'react';

import fetch from '../../fetch';

import moment from 'moment';

import utils from '../../../utils';
import { Tag} from 'antd';

const DataGrid = {
    selections: [],
    refresh: function () {

    }
}

const columns = utils.columns([
    { key: '$index', label: '序号', width: 75 },
    { key: 'userNo', label: '工号', width: 120 },
    { key: 'userName', label: '听课人姓名', width: 120 },
    {
        key: 'msgStatus', label: '发送状态', width: 120, render: (val) => {
            if (val === 1) {
                return <Tag color={"#999"}>{"发送中"}</Tag>
            }
            if (val === 2) {
                return <Tag color={"green"}>{"发送成功"}</Tag>
            }
            if (val === 3) {
                return <Tag color={"red"}>{"发送失败"}</Tag>
            }
        }
    },
    { key: 'telNumber', label: '手机号', width: 120 },
    { key: 'sendResultDesc', label: '发送结果', width: 150 },
    { key: 'telTitle', label: '发送标题', width: 120 },
    { key: 'createTime', label: '发送时间' },
    { key: 'termName', label: '所属学期' },
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = { pageNum: 1, pageSize: 100 }) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;
    var params = [];
    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };


    return fetch.post('/course/task/tel/message/query', Object.assign(defaultsParams, keywords))
        .then(response => {
            return response.payload.data;
        })
        .then(data => (Object.assign({
            result: data.dataList || [],
            selects: (data.dataList || []).map(d => ({
                value: d.id,
                checked: false
            })),
            checked: false,
            total: data.total,
            pageIndex: data.pageNum,
            pageSize: data.pageSize,
            notify: (data.dataList || []).length ? '' : '暂无数据...'
        })));
}





/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = () => {
    return fetch.get('/course/task/tel/message/remove');
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};


export default {
    querySearch,
    remove,
    columns,
    onSelect,
    setRefresh,
    getSelection,
}